import { CardMedia, Stack } from '@mui/material';
import { MotionViewport } from 'src/components/animate';
import { Props } from 'src/features/@types/scroll';
import { Animate } from 'src/features/global/styles';
import { StyledContainer, StyledLogo, StyledLogoContent, StyledPicture } from './styles';

// -------------------------------------------------------------------------------------

export default function Cover({ resolution }: Props) {
  return (
    <Stack component={MotionViewport}>
      <StyledContainer>
        <StyledLogo>
          <StyledLogoContent>
            <Stack width="70%">
              <CardMedia component="img" image="images/logo.webp" alt="Logo Pafesan" />
            </Stack>
          </StyledLogoContent>
        </StyledLogo>

        {resolution ? (
          <Stack display="flex" width="100%">
            <CardMedia
              component="img"
              image="images/capa/capa2.webp"
              alt="Imagem 1 - Cover"
              style={{ height: '100vh' }}
            />
          </Stack>
        ) : (
          <StyledPicture>
            <Animate>
              <CardMedia
                component="img"
                image="images/capa/capa2.webp"
                alt="Imagem 1 - Cover"
                height="100%"
              />
            </Animate>
            <Animate>
              <CardMedia
                component="img"
                image="images/capa/capa1.webp"
                alt="Imagem 2 - Cover"
                height="100%"
              />
            </Animate>
            <Animate>
              <CardMedia
                component="img"
                image="images/capa/capa3.webp"
                alt="Imagem 3 - Cover"
                height="100%"
              />
            </Animate>
          </StyledPicture>
        )}
      </StyledContainer>
    </Stack>
  );
}
